import { NavLink } from 'react-router-dom';
import { Sparkles, Calendar, Clock, MapPin } from 'lucide-react';
import { cn } from '@/lib/cn';

const navItems = [
  { to: '/specials', label: 'Specials', icon: Sparkles },
  { to: '/events', label: 'Events', icon: Calendar },
  { to: '/happy-hours', label: 'Happy Hours', icon: Clock },
  { to: '/bars', label: 'Bars', icon: MapPin },
];

interface BottomNavProps {
  offset?: number;
}

export function BottomNav({ offset = 0 }: BottomNavProps) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-border glass"
      style={{ transform: `translateY(${offset}px)` }}
    >
      <div className="flex h-16 items-center justify-around">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-1 px-4 py-2 text-xs font-medium transition-colors',
                isActive ? 'text-accent-primary' : 'text-muted hover:text-foreground'
              )
            }
          >
            <Icon className="h-5 w-5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
